/**
 * Version number of the Buildkite plugin.
 * This should match the version in package.json
 */
export const VERSION = '1.3.0';
